module.exports = __webpack_public_path__ + "static/media/state-state2.49bc3782.png";